import { useMemo } from 'react';
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import type { Profile } from '@wlb/shared/types';
import type { FeedPost } from '@wlb/shared/types/post';
import { PopoverMenu } from '../../components/ui/PopoverMenu';
import { buildPostOptions, type PostOptionKey } from './postOptions';

interface PostOptionsModalProps {
  post: FeedPost | null;
  profile: Profile | null;
  anchorRect: DOMRect | null;
  onClose: () => void;
  onSelect: (action: PostOptionKey) => void;
}

export function PostOptionsModal({ post, profile, anchorRect, onClose, onSelect }: PostOptionsModalProps) {
  const { t } = useTranslation();
  const options = useMemo(
    () => (post ? buildPostOptions(post, profile, t) : []),
    [post, profile, t],
  );

  if (!post) return null;

  return (
    <PopoverMenu
      anchorRect={anchorRect}
      items={options}
      label={t('home.postOptions.title')}
      labelledBy="post-options-modal-title"
      onClose={onClose}
      onSelect={onSelect}
    />
  );
}
